import { Dispatch, SetStateAction } from "react";
import ContentTitle from "../common/ContentTitle";
import NextBtn from "../common/NextBtn";
import PreviousBtn from "../common/PreviousBtn";
import AddressField from "./AddressField";
import AddressFieldPreView from "./AddressFieldPreView";
import styles from "./CreateMapSetting.module.css";

interface PopupSettingProps {
    processIdx: number;
    canProceed: boolean;
    setCanProceed?: Dispatch<SetStateAction<boolean>>;
    progressProcess: (n: number) => void;
    AddressFieldMapData: string[][];
    selectedAddressIdx: number;
    setSelectedAddressIdx: Dispatch<SetStateAction<number>>;
}

/**
 * @author cjs
 * @date 2024-09-12 11:26:58
 * @remark 지도만들기 주소필드 컴포넌트
 * @param props
 * @props PopupSettingProps
 *      processIdx(required) : 지도만들기 과정 페이지 번호
 *      progressProcess(required) : 지도만들기 과정 페이지 변경 함수
 *      AddressFieldMapData(required) : 지도 데이터
 * @returns AddressFieldSetting
 */
function AddressFieldSetting(props: PopupSettingProps) {
    return (
        <>
            <div className={styles.wrapPreView}>
                <AddressFieldPreView />
            </div>
            <div className={`${styles.wrap} undraggable`}>
                <div className={styles.container}>
                    <div className={styles.title}>
                        <ContentTitle title="주소필드" />
                    </div>
                    {
                        <AddressField
                            AddressFieldMapData={props.AddressFieldMapData}
                            selectedAddressIdx={props.selectedAddressIdx}
                            setSelectedAddressIdx={props.setSelectedAddressIdx}
                        />
                    }
                    <div className={styles.footer}>
                        <div className={styles.wrapProgressBtn}>
                            <div className={`${props.processIdx === 0 ? styles.hideBtn : styles.activeBtn}`}>
                                <PreviousBtn progressProcess={props.progressProcess} />
                            </div>
                            <NextBtn progressProcess={props.progressProcess} canProceed={props.canProceed} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddressFieldSetting;
